import React from 'react';
import "./MailToolbar.css";
import TextLabel from "../../../Controls/TextLabel.mjs";
import MailsentIcon from "../../../media/images/MailsentIcon.mjs";
import WritenewIcon from "../../../media/images/WritenewIcon.mjs";
import InboxIcon from "../../../media/images/InboxIcon.mjs";
import appLib from "../../../libs/appLib.mjs";

const G = window.glob;

const MailToolbar = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('MailToolbar');
	}
	render() {
		const v = this.props.value;
		return (
			<div className={"AppToolbar MailToolbar"} id={this.uid}>
				<div
					className={"ToolbarTab " + (v === 'inbox' ? 'active' : 'inactive')}
					onClick={ ()=>{ this.props.onChange('inbox') }}
				>
					<InboxIcon />
					<span className={v === 'inbox' ? '' : 'nomobile'}>
						<TextLabel value={"Inbox"}/>
					</span>
				</div>
				<div
					className={"ToolbarTab " + (v === 'sent' ? 'active' : 'inactive')}
					onClick={ ()=>{ this.props.onChange('sent') }}
				>
					<MailsentIcon/>
					<span className={v === 'sent' ? '' : 'nomobile'}>
						<TextLabel value={"Sent mail"}/>
					</span>
				</div>
				<div className={"ToolbarButtonbar"}>
					{ appLib.userCanSendMail() && (
						<div
							className={"ToolbarButton gameRunning"}
							onClick={e => {
								e.preventDefault();
								G.trigger('WriteNewMail')
							}}
						>
							<WritenewIcon/>
							<span className={"nomobile"}>
								<TextLabel value={"New Email"}/>
							</span>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default MailToolbar;